const consumerAssetTypes = [
  {
    label: "Motor Vehicle",
    icon: "DirectionsCar",
    category: 1,
    value: "",
    modalTypeCode: "APAS",
    modelSpecificationCode: "A",
  },
  {
    label: "Electric Motor Vehicle",
    icon: "DirectionsCar",
    category: 1,
    value: "",
    modalTypeCode: "APAS",
    modelSpecificationCode: "A",
  },
  {
    label: "Luxury Vehicle",
    icon: "DirectionsCar",
    category: 1,
    modalTypeCode: "APAS",
    value: "",
    modelSpecificationCode: "A",
  },
  {
    label: "Motorbike",
    icon: "Fastfood",
    category: 3,
    modalTypeCode: "B",
    value: "",
    modelSpecificationCode: "B",
  },
  {
    label: "Motorbike (Off Road)",
    icon: "Fastfood",
    category: 3,
    modalTypeCode: "B",
    value: "",
    modelSpecificationCode: "B",
  },
  {
    label: "ATV",
    icon: "Fastfood",
    category: 3,
    modalTypeCode: "B",
    value: "",
    modelSpecificationCode: "B",
  },
  {
    label: "Tractor",
    icon: "Fastfood",
    category: 3,
    modalTypeCode: "",
    value: "",
    modelSpecificationCode: "",
  },
  {
    label: "Ride on mower",
    icon: "Fastfood",
    category: 3,
    modalTypeCode: "",
    value: "",
    modelSpecificationCode: "",
  },
  {
    label: "Horse float",
    icon: "Build",
    category: 2,
    modalTypeCode: "",
    value: "",
    modelSpecificationCode: "C",
  },
  {
    label: "Trailer",
    icon: "Build",
    category: 2,
    modalTypeCode: "",
    value: "",
    modelSpecificationCode: "C",
  },
  {
    label: "Caravan",
    icon: "Build",
    category: 2,
    modalTypeCode: "C",
    value: "",
    modelSpecificationCode: "C",
  },
  {
    label: "Motor home",
    icon: "Build",
    category: 2,
    modalTypeCode: "C",
    value: "",
    modelSpecificationCode: "C",
  },
  {
    label: "Trailered boat",
    icon: "Build",
    category: 2,
    modalTypeCode: "",
    value: "",
    modelSpecificationCode: "M",
  },
  {
    label: "Jetski/PWC",
    icon: "Build",
    category: 2,
    modalTypeCode: "",
    value: "",
    modelSpecificationCode: "M",
  },
  {
    label: "Jetski/PWC with Trailer",
    icon: "Build",
    category: 2,
    modalTypeCode: "",
    value: "",
    modelSpecificationCode: "M",
  },
  {
    label: "Golf carts",
    icon: "Build",
    category: 2,
    modalTypeCode: "",
    value: "",
    modelSpecificationCode: "",
  },
  {
    label: "SSV",
    icon: "DirectionsCar",
    category: 3,
    modalTypeCode: "C",
    value: "",
    modelSpecificationCode: "C",
  },
  {
    label: "Outboard Motor",
    icon: "DirectionsCar",
    category: 3,
    modalTypeCode: "",
    value: "",
    modelSpecificationCode: "M",
  },
  {
    label: "Control Box",
    icon: "DirectionsCar",
    category: 3,
    modalTypeCode: "",
    value: "",
    modelSpecificationCode: "",
  },
  {
    label: "Diesel Engine",
    icon: "DirectionsCar",
    category: 3,
    modalTypeCode: "",
    value: "",
    modelSpecificationCode: "",
  },
  {
    label: "Aluminium Boats",
    icon: "DirectionsCar",
    category: 3,
    modalTypeCode: "",
    value: "",
    modelSpecificationCode: "M",
  },
  {
    label: "Stern Drive",
    icon: "DirectionsCar",
    category: 3,
    modalTypeCode: "",
    value: "",
    modelSpecificationCode: "M",
  },
  {
    label: "Electric Bicycle",
    icon: "DirectionsCar",
    category: 3,
    modalTypeCode: "",
    value: "",
    modelSpecificationCode: "",
  },
  {
    label: "MBK Bicycle",
    icon: "DirectionsCar",
    category: 3,
    modalTypeCode: "",
    value: "",
    modelSpecificationCode: "",
  },
  {
    label: "Inboard Motors",
    icon: "DirectionsCar",
    category: 3,
    modalTypeCode: "",
    value: "",
    modelSpecificationCode: "M",
  },
  {
    label: "Marine Package",
    icon: "DirectionsCar",
    category: 3,
    modalTypeCode: "",
    value: "",
    modelSpecificationCode: "M",
  },
];
export default consumerAssetTypes;
